import { useEffect, useState } from 'react';
import { useAuth } from '@hilma/auth';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const AuthSuccess: React.FC = () => {
    const auth = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const classes = useStyles();
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        const token = searchParams.get('token');

        if (!token) {
            setFailed(true);
            return;
        }

        auth.setAuthItem(auth.accessTokenCookie as never, token)
            .then(() => {
                sessionStorage.setItem('loggedIn', 'true');
                navigate('/requests/pending', { replace: true });
            })
            .catch(() => setFailed(true));
    }, [auth, navigate, searchParams]);

    if (failed) return <Navigate to="/auth/error" replace />;

    return (
        <div className={classes.root}>
            <CircularProgress />
            <span className={classes.text}>מתחבר למערכת...</span>
        </div>
    );
};

export default AuthSuccess;

const useStyles = makeStyles({
    root: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '16px',
        direction: 'rtl',
    },
    text: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#24364b',
    },
});
